package org.multiplatform.kotfolio.pages.coroutines

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("/coroutines/questions")
@Composable
fun QuestionsCoroutinesPage() {
    BlogLayout(
        PageProperties(
            "Interview Question",
            "Top Kotlin Coroutines interview questions asked to experienced/fresher candidates during interviews at various organizations."
        ),
        BlogProperties("Coroutines", "Interview Question")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ol {
                Li {
                    SpanText(
                        text = "What are the advantages of using structured concurrency over launching coroutines independently?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Structured concurrency helps manage the lifecycle and cancellation of coroutines by enforcing that child coroutines are canceled when their parent coroutine is canceled. This prevents resource leaks and ensures that all coroutines within a scope complete or get canceled together, providing better control and reliability.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "How do you handle concurrency issues, such as race conditions, when working with coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines inherently provide protection against race conditions by executing code sequentially within a single thread or dispatcher. If shared mutable state needs to be accessed concurrently, you can use synchronization mechanisms like Mutex or Atomic types to ensure thread-safety.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "What are the advantages of using structured concurrency over launching coroutines independently?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Structured concurrency helps manage the lifecycle and cancellation of coroutines by enforcing that child coroutines are canceled when their parent coroutine is canceled. This prevents resource leaks and ensures that all coroutines within a scope complete or get canceled together, providing better control and reliability.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "How does structured concurrency help in managing resource cleanup?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Structured concurrency ensures that all coroutines within a scope complete or get canceled together. This helps in managing resource cleanup by automatically canceling and releasing resources associated with the coroutines when they are no longer needed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "What are Kotlin Coroutines, and how are they different from traditional threading?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Threads: Managed by the OS, heavy, resource-intensive, context switching is expensive.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines: Managed by Kotlin/JVM, very lightweight (thousands can run on a single thread), context switching is cheap. They allow functions to pause and resume without blocking the underlying thread.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concepts of Observables and Observers in Reactive Programming.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Observables are sources of data that emit items over time, and Observers subscribe to these observables to react to the emitted items.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    Li {
                        SpanText(
                            text = "How does backpressure work in Reactive Programming?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Backpressure is a mechanism to handle scenarios where an observable produces data at a faster rate than the observer can consume. It allows the observer to signal the producer to slow down or buffer data.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                        SpanText(
                            text = "What is the difference between Cold and Hot Observables in Reactive Programming?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Cold observables start emitting items only when a subscriber subscribes, while hot observables emit items regardless of whether there are subscribers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Hot observables share the same stream of data among multiple subscribers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                        SpanText(
                            text = "Explain the concept of hot and cold observables in detail.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A cold observable starts emitting items when a subscriber subscribes, while a hot observable emits items regardless of subscribers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Cold observables provide a separate set of emissions for each subscriber, while hot observables share emissions among multiple subscribers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                Li(Modifier.padding(top = 1.0.em).toAttrs()) {
                    SpanText(
                        text = "Cold Flow vs Hot Flow",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cold Flow is a type of Kotlin Flow that emits data only when there is a collector. It doesn't store any data and starts emitting values only when a collector subscribes to it. Each collector receives all the values from the beginning of the Flow independently, as if they have their individual flow.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Hot Flow is a type of Kotlin Flow that emits data continuously, even when there is no collector. It can have multiple collectors, and each collector receives values from where they started collecting. It's like a 1-to-N mapping, where one Flow serves multiple collectors, and each collector receives data based on their individual subscription time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "Explain the role of schedulers in Reactive Programming.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Schedulers in Reactive Programming determine the execution context of observables and observers. They control where the observable emits items and where the observer consumes them.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 1.em).toAttrs()) {

                    SpanText(
                        text = "What is the purpose of subjects in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Subjects act as both observables and observers.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They can emit items and be subscribed to, making them useful for multicasting and bridging non-reactive code with reactive code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How can you handle errors in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Errors in Reactive Programming can be handled using operators like onErrorResumeNext or retry. Subscribers can also provide error handlers to react to errors.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does the debounce operator work in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The debounce operator is used to filter out rapid emissions from an observable.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It introduces a delay, and if no new items are emitted during that delay, the last emitted item is delivered to the observer.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does the flatMap operator differ from map in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The map operator transforms each item emitted by an observable,",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "while the flatMap operator transforms each item into another observable. It is often used for flattening nested observables.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How can you implement a retry mechanism for network requests in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The retry operator is used to resubscribe to an observable in case of an error.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It can be combined with strategies like retryWhen to provide custom logic for retry attempts.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the concept of multicasting in Reactive Programming.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Multicasting involves sharing the emissions of a single observable among multiple subscribers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Subjects are often used for multicasting in Reactive Programming.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "What is the purpose of the combineLatest operator in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The combineLatest operator combines the latest emissions from multiple observables into a single observable, emitting a new combined value whenever any of the source observables emit an item.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "How does the observeOn operator work in Reactive Programming?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The observeOn operator specifies the scheduler on which the observer should observe items emitted by the observable. It allows controlling the thread on which the observer consumes the items.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the role of the collectAsState extension function in Jetpack Compose.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "collectAsState is an extension function that collects a StateFlow and provides a State to be used in composables. It automatically handles state changes and triggers recompositions. collectAsState is used to convert a Flow or StateFlow into a state variable that can be observed by Jetpack Compose.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Collects values from a Kotlin coroutine StateFlow and is observed by Compose.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Changes in the flow trigger recomposition.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is a coroutine in Kotlin? How does it differ from regular threads or callbacks?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin’s coroutines are a lightweight concurrent programming feature that enable asynchronous, non-blocking code execution. Coroutines are user-level constructions controlled by the Kotlin runtime, in contrast to threads, which are OS-level entities.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They may be stopped and resumed, which makes them more memory-efficient and appropriate for managing asynchronous tasks without the overhead of conventional threads. Additionally, callback-based programming is less legible and maintainable than coroutines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the key advantages of using coroutines over traditional callback-based or thread-based concurrency models.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They simplify asynchronous code, making it more readable and maintainable.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They eliminate callback hell (pyramid of doom) by using sequential code structures.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines are more memory-efficient than creating a large number of threads.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They allow for structured concurrency, ensuring that all launched coroutines are properly managed.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines can easily handle cancellation, timeouts, and error handling.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How can you handle cancellation in coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cancellation in coroutines is cooperative. You can handle cancellation by periodically checking the isActive property within a coroutine or by using functions like ensureActive() or yield() to check for cancellation points. Additionally, you can use withTimeout or withTimeoutOrNull to set a timeout for coroutines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How can you handle timeouts in Kotlin Coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Timeouts in coroutines can be handled using the `withTimeout` or `withTimeoutOrNull` functions. They allow you to specify a maximum duration for the execution of a coroutine, and the coroutine will be cancelled if it exceeds that duration.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Explain the concept of coroutine cancellation and how it differs from thread interruption.",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutine cancellation is a cooperative mechanism where a coroutine is given the opportunity to clean up resources before it is cancelled. It differs from thread interruption, which forcefully stops a thread without giving it a chance to perform cleanup.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Coroutine different from Thread",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        SpanText(
                            text = "Concurrency vs Parallelism",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Threads are typically associated with parallelism, where multiple threads run simultaneously on multiple CPU cores. Each thread is a separate unit of execution that is multiple tasks are making progress at the same point of time (parrallely).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines, on the other hand, are designed for concurrency. Multiple tasks are making progress at the same time (concurrently) but if the system has only one CPU, only one task will make progress at a given point of time.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul {
                        SpanText(
                            text = "Resource Consumption",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Threads are heavy in resource consumption. Creating and managing threads can be resource-intensive, and having too many threads can lead to high memory and CPU usage.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines are light weight as they are managed by a coroutine dispatcher, which can be a single thread. Many coroutines can be launched on a single thread without consuming much memory as all coroutines will use the same thread turn by turn to perform their operations.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Synchronisation and Data sharing",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "Threads share memory space and require synchronisation mechanisms like locks, mutexes and semaphores to avoid data races and ensure thread safety.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "Coroutines do not share memory by default, which makes them safer for concurrent programming. Data can be shared between coroutines using structured concurrency and channels, which simplifies synchronisation.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Cancellation",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "Stopping or cancelling threads can be challenging and may lead to resource leaks.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "Coroutines can be cancelled gracefully, releasing resources and cleaning up after themselves.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Blocking vs Non-blocking",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "Threads can block, causing the entire thread to pause while waiting for I/O or other operations to complete.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "Coroutines are non-blocking by default, allowing other coroutines to continue running while one coroutine is waiting for I/O or other operations.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Error Handling",
                            modifier = Modifier.padding(topBottom = 0.2.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li {
                            SpanText(
                                text = "Handling errors in Threads can be challenging and unhandled exceptions can crash the application",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "Coroutines have built-in structured error handling using try-catch blocks, make it easier to handle errors gracefully.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between coroutines and threads?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Threads are managed by the operating system and are relatively expensive in terms of memory and context switching. Coroutines, on the other hand, are lightweight and can be multiplexed on a smaller number of threads. They provide a way to handle concurrency without the need for explicit thread management.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Create 100,000 threads",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Create 100,000 coroutines",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Scale it up to 1 million coroutines",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "The Astonishing Results",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Traditional Threads: A staggering 25 seconds to complete the task.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "100,000 Coroutines: Blazing through in just 197 milliseconds.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "1 Million Coroutines: Still impressively fast at 641 milliseconds.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Concurrency?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Coroutines are lightweight threads that can be used for asynchronous programming. They simplify asynchronous code by providing a way to write sequential code that suspends execution without blocking the thread.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "AsyncTask",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "AsyncTask is an older mechanism in Android for performing background tasks. Although it has been deprecated in favor of other concurrency mechanisms like coroutines, it's still worth mentioning as it's used in many legacy codebases.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Threads and Handlers",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Android also supports traditional concurrency mechanisms like creating threads and using Handlers for communication between threads. However, these approaches require more manual management and are often less preferred compared to coroutines.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Schedulers",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Android provides schedulers such as AsyncTask, Handler, Looper etc. for managing concurrency and performing operations on specific threads.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    Ul {
                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Executors and Thread Pools",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Android's Executor framework allows you to manage a pool of threads for executing tasks concurrently. This can be more efficient than creating new threads for each task.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is Kotlin Coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines are Kotlin’s native solution for writing asynchronous, non-blocking code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They allow developers to write sequential code that looks like traditional synchronous code while taking advantage of suspending functions and structured concurrency design pattern introduced by JetBrains for the Kotlin programming language.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do you create a coroutine in Kotlin?",
                        modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Coroutines are created using the launch or async builders. The launch builder is used for fire-and-forget style coroutines, while async is used when you need to return a result from the coroutine. Both builders require a coroutine scope to launch the coroutine.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Discuss the role of the CoroutineStart parameter in coroutine builders.",
                        modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "`CoroutineStart` parameter in coroutine builders, such as `launch` and `async`, specifies the behavior of coroutine execution. Options include `DEFAULT` (lazy start), `ATOMIC` (start atomically), and `UNDISPATCHED` (start on the current thread, skipping the dispatcher).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "What is structured concurrency?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Single line answer: Structured concurrency is an approach to managing coroutines that ensures the proper execution and completion of all child coroutines within a specific scope. It helps in avoiding common pitfalls associated with coroutine management.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Structured concurrency is a pattern that ensures the proper handling of coroutines by enforcing the cancellation of child coroutines when their parent coroutine is canceled.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It helps avoid resource leaks and guarantees that all coroutines within a scope complete successfully or get canceled together.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin coroutines follow the principle of structured concurrency, which means that the lifecycle of a coroutine is tied to its parent scope. When the parent scope is canceled or completed, all child coroutines launched within it are also canceled. This ensures proper cleanup and prevents resource leaks.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Why do we need Kotlin Coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Simplified Asynchronous Code: Traditionally, async programming models like callbacks, futures, and promises can lead to “callback hell” or deeply nested structures. Coroutines simplify this with linear-looking code.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Lightweight: Coroutines are lightweight compared to threads. You can launch thousands of them, and they won’t bring your system to a halt.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flexible Flow Control: They offer better flow control using suspend functions, allowing you to decide when to pause and resume work.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Integration with Kotlin Flow: For reactive-style streams, Kotlin was introduced Flow which integrates seamlessly with coroutines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do you ensure thread safety when working with shared data within coroutines?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Ensuring thread safety when working with shared data within coroutines is essential to prevent data corruption and race conditions.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Suspend Functions and Coroutines",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = " Use suspend functions and structured concurrency with coroutines to ensure that multiple coroutines don't access shared data simultaneously. This helps avoid data races.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Mutex and Semaphore",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can use synchronization primitives like Mutex or Semaphore to protect critical sections of code where shared data is accessed. A Mutex allows only one coroutine to access the protected code at a time, preventing concurrent access.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                 val mutex = Mutex()
                                 var sharedData = 0

                                 suspend fun modifySharedData() {
                                     mutex.withLock {
                                         sharedData++
                                     }
                                 }
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                class Store<T>(initialState: T) {

                                    private val  _state = MutableStateFlow(initialState)
                                    val state : StateFlow<T> = _state.asStateFlow()

                                    private val mutex = Mutex()

                                    suspend fun update(updateBlock: (T) -> T) = mutex.withLock {
                                        val newState = updateBlock(_state.value)
                                        _state.value = newState
                                    }

                                    suspend fun read(readBlock: (T) -> Unit) = mutex.withLock {
                                        readBlock(_state.value)
                                    }
                                }
                            """.trimIndent()
                        )

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Thread-Safe Data Structures",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Kotlin’s standard library provides thread-safe data structures, such as ConcurrentHashMap and atomic variables. These data structures are designed to handle concurrent access without the need for external synchronization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                 val sharedMap = ConcurrentHashMap<String, Int>()
                                 sharedMap["key"] = 42

                                 val atomicInt = atomic(0)
                                 atomicInt.incrementAndGet()
                            """.trimIndent()
                        )

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Immutable Data",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Whenever possible, use immutable data structures. Immutable data can be shared among multiple coroutines without the need for locks because it cannot be modified once created.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                 data class ImmutableData(val value: Int)

                                 val sharedImmutableData = ImmutableData(42)
                            """.trimIndent()
                        )

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Atomic Operations",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For simple counters or flags, consider using atomic operations like AtomicInt or AtomicBoolean. These provide atomic read-modify-write operations that are thread-safe.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Li(Modifier.padding(top = 1.em).toAttrs()) {
                            SpanText(
                                text = "Avoid Shared Mutable State",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Minimize shared mutable state as much as possible. Instead, prefer communication through channels or other mechanisms where coroutines can exchange data without direct shared access.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does Kotlin Coroutines handle thread safety and concurrent access to shared mutable state?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin Coroutines provide mechanisms such as `Mutex` and `Atomic` operations to handle thread safety and prevent data races when multiple coroutines access shared mutable state concurrently. Additionally, using immutable data structures can help mitigate concurrency issues.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How does coroutine suspension work under the hood in terms of stack frames?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Kotlin coroutines use continuation-passing style (CPS) for suspension. Unlike traditional thread-based models where the execution context (stack) is preserved, coroutines store their continuation (state) on the heap. This allows the coroutine to suspend and resume without blocking a thread. When a coroutine is suspended, its state is saved, and it can resume at a later point, effectively decoupling its execution from the thread. This approach allows Kotlin to achieve non-blocking I/O and background work while keeping the system resource-efficient.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "How do you handle long-running coroutines to prevent blocking the main/UI thread?",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Long-running coroutines should be executed on a thread other than the main/UI thread to prevent blocking. You can use the Dispatchers.Default dispatcher or create a custom thread pool using newFixedThreadPoolContext() to run long-running coroutines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {

                    SpanText(
                        text = "Why do we need Kotlin Coroutines? (What does the suspend modifier tells us?)",
                        modifier = Modifier.fontSize(FontSize.Large)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When we use suspending functions we don’t block the underlying thread.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A suspending function is a function that can be paused and resumed at a later time. They can execute a long running operation and wait for it to complete without blocking. (Each suspending function is responsible for specific computation which may takes some time to be completed so we allow to pause its execution for some time to release the thread for other tasks and when the computation it’s completed we resume it.)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "These functions can be used within coroutines and are a central part of the coroutine ecosystem.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Can only be called from another suspend function or a coroutine.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        SpanText(
                            text = "Points to remember:",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Suspend functions can be invoked only inside another suspend function or a coroutine builders",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A suspend function will only return once its execution is complete, meaning that any code following a call to a suspend function will not be executed until the function has finished running.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if a suspend function is called on a thread and a suspension point is hit? Does it block the thread? How does it manage the thread once the suspension is over?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A suspend function doesn’t block the thread when it hits a suspension point. Instead, the coroutine’s state is saved, and the thread is freed for other work. When the task completes, the coroutine resumes on the thread specified by the dispatcher, not necessarily the same thread it was suspended on.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does chaining multiple suspend functions work under the hood? What happens if one suspend function calls another, and both hit suspension points?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "When one suspend function calls another, the current function is suspended, and the Continuation object for the calling function is stored. The suspension propagates up the chain until all functions resume. Each suspend function has its own continuation that tracks where to resume after the suspension is over.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if you try to call a suspend function inside a regular function without using a coroutine? Can you invoke a suspend function outside of a coroutine context?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You cannot directly call a suspend function inside a regular function because it requires a coroutine to manage its suspension. However, you can invoke a suspend function by wrapping it in a coroutine using runBlocking or starting a new coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Why can’t you call suspend functions from regular (non-suspending) functions directly, and what design patterns exist to address this issue in complex systems?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can’t call suspend functions directly from non-suspending functions because suspend functions are designed to suspend the execution of the coroutine at certain points. Non-suspending functions do not have this capability, and calling a suspend function would lead to blocking behavior. This distinction is vital when integrating coroutines into non-suspending code paths.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li {
                                    SpanText(
                                        text = "Use launch or async to invoke suspending functions within coroutines.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li {
                                    SpanText(
                                        text = "runBlocking is sometimes used to bridge regular and suspending code in entry points like main().",
                                        modifier = Modifier.padding(bottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How are exceptions handled in a suspend function? If an exception is thrown during the suspension, what happens to the continuation? Does it resume or abort the coroutine?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If an exception is thrown in a suspend function, the continuation is resumed with the failure (Result.failure). The exception can be caught using a try-catch block within the coroutine. If not caught, the coroutine fails, and its exception is handled by the CoroutineExceptionHandler or propagated to the parent coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Is it possible to call a non-suspend function from a suspend function? If so, what impact does this have on the suspension behavior?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Yes, you can call a non-suspend function from a suspend function without any issues. However, calling a non-suspend function does not introduce any suspension points, so the coroutine will continue executing without being paused unless it encounters a suspend function later.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if a suspend function is suspended but the result it was waiting for is never delivered (e.g., an infinite delay or network timeout)? How does the coroutine handle this situation?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If the result never arrives (for example, the coroutine is suspended indefinitely due to an infinite delay or a network request that never completes), the coroutine remains suspended. You can use a timeout mechanism (like withTimeout()) to ensure that the coroutine is cancelled after a certain period if no result is received.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does suspension and resumption behave in nested coroutine scopes? What happens if a suspend function is called in a child coroutine and the parent coroutine is cancelled?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If a parent coroutine is cancelled, all its child coroutines are also cancelled. If a child coroutine calls a suspend function and the parent cancels before the function resumes, the child coroutine will be cancelled, and the suspension will not complete. All suspended child coroutines are aborted when the parent is cancelled.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can you pass a suspend function as a parameter to a higher-order function? How does Kotlin handle the suspension within such a function?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Yes, you can pass a suspend function as a parameter to a higher-order function. Kotlin allows higher-order functions to have suspend function types. The higher-order function itself must be a suspend function to call the suspend function parameter and handle the suspension correctly.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Does using a suspend function introduce additional performance overhead compared to non-suspend functions? If so, where does this overhead come from?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Yes, suspend functions introduce some overhead because they involve creating and maintaining the Continuation object, as well as transforming the function into a state machine. However, this overhead is typically small and worth the trade-off for non-blocking asynchronous operations. The exact overhead depends on how many suspension points and coroutine dispatching mechanisms are involved.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if a coroutine is cancelled while a suspend function is in progress? How is the Continuation affected, and what happens to the coroutine’s state?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If a coroutine is cancelled while a suspend function is in progress, the coroutine will not resume when the suspend function completes. The cancellation signal will cause the Continuation to stop, and an exception (CancellationException) will be thrown. The coroutine is then aborted, and its resources are cleaned up.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the purpose of the yield() function in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The yield() function is used to suspend a coroutine, allowing other coroutines to run. It is similar to cooperative multitasking, where a coroutine voluntarily yields its execution to give the opportunity for other coroutines to execute.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is structured concurrency, and how do coroutines support it?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutines follow a principle of structured concurrency which means new coroutines can only be launched in a specific CoroutineScope which controls the lifetime of the coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Coroutines launched within a scope are automatically canceled when the scope is canceled, ensuring proper cleanup and avoiding resource leaks.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the concept of structured concurrency in the context of exception handling.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Structured concurrency ensures that exceptions are properly handled within the context of the parent coroutine. If an exception occurs in a child coroutine, it is propagated to the parent coroutine, allowing for centralized exception handling and cleanup.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you limit the number of concurrent coroutines running at the same time?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can limit the number of concurrent coroutines using a semaphore-based mechanism. By using a limited-size Semaphore or a custom CoroutineDispatcher, you can control the number of coroutines that can run concurrently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can you explain the concept of structured concurrency with nested coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Structured concurrency promotes the idea of launching child coroutines within a parent coroutine’s scope. When using nested coroutines, the parent coroutine will wait for all its child coroutines to complete before it completes itself. This ensures proper cleanup and cancellation of all coroutines within the hierarchy.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a Cold Flow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "That emits data only when there is a collector.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It doesn’t store any data and starts emitting values only when a collector subscribes to it.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Each collector receives all the values from the beginning of the Flow independently, as if they have their individual flow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a Hot Flow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "That emits data continuously, even when there is no collector.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It can have multiple collectors, and each collector receives values from where they started collecting.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It’s like a 1-to-N mapping, where one Flow serves multiple collectors, and each collector receives data based on their individual subscription time.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the difference between cold flow and hot flow in coroutine.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Cold Flow emits data only when there is a collector, doesn’t store data, and each collector receives all the values from the beginning.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Hot Flow emits data continuously, can store data, and each collector receives data from where they started collecting.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can you describe how suspend functions work in Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Functions that can be paused, allowing other tasks to run, and then resumed when the operation completes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "They are functions that can be paused and resumed without blocking the underlying thread. Suspend functions enable developers to write non-blocking code in a sequential and more readable manner.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "When a suspend function is called, it doesn’t block the thread but instead provides an opportunity for other tasks to be executed. This behavior is achieved by utilizing the power of coroutines and the suspend modifier.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Are suspend functions executed by default on the main thread or some other one?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "By default, suspend functions are executed on a background thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if we call a suspend function from another suspend function?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "When we call a suspend function from another suspend function, the first function will suspend execution until the second function completes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "This can be used to our advantage to create asynchronous code that is easy to read and debug.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the concept of Coroutine Builders in Kotlin.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine Builders are functions that are used to create and start coroutines. Examples include launch, async, and runBlocking. They provide a convenient way to initiate and control the execution of coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "launch() will create a new coroutine and start it immediately, while async() will create a new coroutine but will not start it until something calls await() on the resulting Deferred object.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "In general, launch() should be used when you want a coroutine to run in the background without blocking the main thread, while async() should be used when you need to wait for the result of a coroutine before continuing.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the difference between launch and async.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Both are used to launch coroutines but launch is used when you don’t need a result back whereas async is used when you need a result.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "launch() will create a new coroutine and start it immediately, while async() will create a new coroutine but will not start it until something calls await() on the resulting Deferred object.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "In general, launch() should be used when you want a coroutine to run in the background without blocking the main thread, while async() should be used when you need to wait for the result of a coroutine before continuing.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = " Explain the difference between async and launch in coroutines.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            SpanText(
                                text = "Both async and launch are coroutine builders in Kotlin.",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "launch()",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Used for launching a fire-and-forget coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "launch() should be used when you want a coroutine to run in the background without blocking the main thread, execution of the rest part of the code will not wait for the launch result since launch is not a suspend call.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It starts a new coroutine and doesn’t return any result.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It’s suitable for performing tasks concurrently without waiting for the result.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "async()",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Used for launching a coroutine that produces a result. It returns a Deferred object, which is a promise to deliver the result later. You can use await() on a Deferred to get the result. async is useful when you need to perform concurrent tasks and gather their results.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What are the potential pitfalls of using launch in a high-concurrency system where many tasks are running in parallel?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "While launch is an easy way to create coroutines, there are potential pitfalls when launching many coroutines in parallel:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li {
                                    SpanText(
                                        text = "Resource contention: Launching too many coroutines concurrently can saturate system resources and degrade performance.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Ol {
                                    Li {
                                        SpanText(
                                            text = "Uncaught exceptions: Since launch doesn’t return a result, uncaught exceptions can silently fail without proper error handling.",
                                            modifier = Modifier.padding(topBottom = 0.2.em)
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li {
                                        SpanText(
                                            text = "Cancellation propagation: Cancelling a parent coroutine does not automatically cancel its children, potentially leading to coroutines continuing to run when they shouldn’t.",
                                            modifier = Modifier.padding(bottom = 0.2.em)
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Li {
                                SpanText(
                                    text = "To mitigate these issues, you should consider using bounded dispatchers and exception handling mechanisms like CoroutineExceptionHandler.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you handle errors in Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "In coroutines, exceptions are handled using try/catch blocks. Additionally, the CoroutineExceptionHandler interface can be used to define a global handler for uncaught exceptions within a coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you achieve parallelism using Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Parallelism in coroutines can be achieved using the async builder along with await to await the results. Multiple asynchronous tasks can be started concurrently, and their results can be combined when needed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you achieve sequential execution of coroutines in Kotlin?.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Sequential execution of coroutines can be achieved by using `async` along with `await` or by using `runBlocking`. These approaches ensure that one coroutine completes before the next one starts.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain async/await advantage.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Suspending Functions: Async/await leverages suspending functions instead of blocking threads. These functions can pause their execution while waiting for asynchronous operations to complete, allowing other coroutines to run concurrently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "learn Code: The pattern promotes clean and readable code that resembles sequential, synchronous code, even when dealing with asynchronous operations.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain await.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "When you have launched a single coroutine through async {}, you can use the await function to wait for its completion and retrieve the result.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Suspends the current coroutine’s execution until the value within the async block becomes available.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "The await function is a suspending function that waits for the completion of the Deferred and returns the result.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = $$"""
                                    import kotlinx.coroutines.*

                                    fun main() = runBlocking {
                                        // Start an asynchronous computation using async block
                                        val deferredResult: Deferred<Pair<String, String>> = async {
                                            fetchAsyncData("Server A")
                                        }

                                        // Other work can be done here concurrently

                                        // Now, retrieve the result of the async computation using `await`
                                        val result = deferredResult.await()
                                        println("Received data: $result")
                                    }

                                    suspend fun fetchAsyncData(server: String): Pair<String, String> {
                                        delay(2000)
                                        val data = "Async data from $server"
                                        return server to data
                                    }
                                """.trimIndent()
                            )
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the difference between launch and runBlocking functions in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "launch is a coroutine builder that starts a new coroutine and returns a Job object immediately without blocking the current thread. It is typically used for fire-and-forget style coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "runBlocking is a coroutine builder that blocks the current thread until the coroutine inside it is completed. It is mainly used for writing tests or running top-level coroutine code.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What are dispatchers in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Dispatchers determine what thread or threads the coroutine uses. Dispatchers provide the context in which coroutines run. They define the thread or thread pool on which the coroutine will be executed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Common dispatchers are Main, IO, Default, and Unconfined.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Which dispatcher should you avoid for tasks that require UI updates and why?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Dispatchers.Unconfined should be avoided for tasks that require UI updates because it only runs the first coroutine on the main thread, and subsequent executions can run on different threads. This can lead to unpredictable behavior and potential latency, making it unsuitable for consistent thread confinement required for UI updates.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a Coroutine Dispatcher, and how is it related to threading?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Coroutine Dispatcher is responsible for determining the thread or threads on which the coroutine will be executed. Common dispatchers include Dispatchers.Main for UI operations and Dispatchers.IO for I/O tasks. They abstract away the complexity of thread management.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the effect of using CoroutineScope(Dispatchers.IO + Job()) in a service?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Using CoroutineScope(Dispatchers.IO + Job()) in a service will handle IO operations efficiently. However, any failure in a child coroutine will cancel all child coroutines within the same scope, which might not be ideal for services that need to handle multiple independent tasks concurrently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the main benefit of combining Dispatchers.IO with SupervisorJob in a CoroutineScope for a service?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Combining Dispatchers.IO with SupervisorJob in a CoroutineScope handles IO operations efficiently and ensures that the failure of one coroutine does not cancel others. This combination provides robustness and resilience, making it ideal for services that need to handle multiple independent tasks concurrently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the role of the produce coroutine builder in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The produce coroutine builder in Kotlin coroutines is used to create a producer coroutine that generates a stream of values and sends them through a channel. This builder is particularly useful when implementing the producer-consumer pattern, where a producer coroutine sends data items that can be consumed by one or more consumer coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = $$"""
                            fun CoroutineScope.produceNumbers(): ReceiveChannel<Int> = produce {
                                for (i in 1..5) {
                                    println("Producing $i")
                                    send(i) // Send each number to the channel
                                    delay(500) // Simulate some work
                                }
                            }

                            fun main() = runBlocking {
                                val numbers = produceNumbers() // Start producing numbers

                                numbers.consumeEach { value ->
                                    println("Consumed $value")
                                    delay(1000) // Simulate some work with each consumed value
                                }
                                println("Done consuming")
                            }
                        """.trimIndent()
                    )
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the concept of coroutine channels and how they can be used for communication between coroutines.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine channels provide a way for coroutines to communicate with each other by sending and receiving data in a non-blocking manner. Channels can be used to implement producer-consumer patterns, stream processing, or any scenario where coroutines need to exchange data. Channels come in different types, such as Channel, BroadcastChannel, and ConflatedBroadcastChannel, each with their own characteristics and use cases.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a channel in Kotlin coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A channel in Kotlin coroutines is a way to communicate between coroutines. (Kotlin coroutines provide Channel as a way to transfer data between coroutines. You can use send and receive functions to send and receive data.)",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is a thread-safe data structure that allows one coroutine to send data to another coroutine. Channels can be used to implement producer-consumer patterns, or to communicate between multiple coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the purpose of the CoroutineExceptionHandler and how can you use it?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "`CoroutineExceptionHandler` is an interface that allows you to define a handler for uncaught exceptions that occur within a coroutine. You can set it using `CoroutineScope.launch` or `GlobalScope.launch` to handle exceptions at the coroutine level.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you handle exceptions in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can use the CoroutineExceptionHandler or wrap your code in a try-catch block within the coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do we do Exception Handling in Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "In case we are using coroutines with network responses and the response returns a null. It could lead to the crashing of the application therefore we use exceptional handling Both launch and async are handled differently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Exception Handling in case of launch function: Try and catch, Handlers",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Using Try and catch",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "We can use try-and-catch functions to catch any exception if the response is null.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                    //1 job cancel
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        // Coroutine body
                                    }
                                    job.cancel() // Cancel the coroutine

                                    //2 Cancelling CoroutineScope
                                    val scope = CoroutineScope(Dispatchers.Default)
                                    val job1 = scope.launch {
                                        // Coroutine 1
                                    }
                                    val job2 = scope.launch {
                                        // Coroutine 2
                                    }

                                    // Cancel all coroutines launched within the scope
                                    scope.cancel()

                                    //3 Cancelling Child Coroutines
                                    val supervisor = SupervisorJob()
                                    val scope = CoroutineScope(Dispatchers.Default + supervisor)
                                    val job1 = scope.launch {
                                        // Coroutine 1
                                    }
                                    val job2 = scope.launch {
                                        // Coroutine 2
                                    }

                                    // Cancel only one of the child coroutines
                                    job1.cancel()

                                    //4  Handling Cancellation
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        while (isActive) {
                                            // Perform task
                                        }
                                    }

                                    //5 Structured Concurrency
                                    class MyViewModel : ViewModel() {
                                        private val viewModelScope = CoroutineScope(Dispatchers.Main)

                                        fun performBackgroundTask() {
                                            viewModelScope.launch {
                                                // Coroutine body
                                            }
                                        }

                                        override fun onCleared() {
                                            super.onCleared()
                                            viewModelScope.cancel() // Cancel all coroutines when ViewModel is cleared
                                        }
                                    }

                                    //6 Handling Cancellation Exceptions
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        try {
                                            // Perform task
                                        } catch (e: CancellationException) {
                                            // Handle cancellation
                                        }
                                    }
                                """.trimIndent()
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "CoroutineExceptionHandlers",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Exception Handling in the case of async and await:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Using Coroutinescope: Coroutinescope is used to launch multiple async and await suspended functions and the app would not crash even if its network response returns null.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Using Supervisor Scope: Supervisorscope is used in case we want to return an empty response even if a network response returns null. We can not return an empty response in case of coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "SupervisorJob",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "When using supervisor jobs, exceptions in one child coroutine won’t affect others.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "CoroutineScope’s CoroutineExceptionHandler",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "You can also specify a CoroutineExceptionHandler when creating a CoroutineScope. This handler will catch exceptions thrown by all coroutines launched within the scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do we do Exception Handling in Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "In case we are using coroutines with network responses and the response returns a null. It could lead to the crashing of the application therefore we use exceptional handling Both launch and async are handled differently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Exception Handling in case of launch function: Try and catch, Handlers",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Using Try and catch",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "We can use try-and-catch functions to catch any exception if the response is null.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                    //1 job cancel
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        // Coroutine body
                                    }
                                    job.cancel() // Cancel the coroutine

                                    //2 Cancelling CoroutineScope
                                    val scope = CoroutineScope(Dispatchers.Default)
                                    val job1 = scope.launch {
                                        // Coroutine 1
                                    }
                                    val job2 = scope.launch {
                                        // Coroutine 2
                                    }

                                    // Cancel all coroutines launched within the scope
                                    scope.cancel()

                                    //3 Cancelling Child Coroutines
                                    val supervisor = SupervisorJob()
                                    val scope = CoroutineScope(Dispatchers.Default + supervisor)
                                    val job1 = scope.launch {
                                        // Coroutine 1
                                    }
                                    val job2 = scope.launch {
                                        // Coroutine 2
                                    }

                                    // Cancel only one of the child coroutines
                                    job1.cancel()

                                    //4  Handling Cancellation
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        while (isActive) {
                                            // Perform task
                                        }
                                    }

                                    //5 Structured Concurrency
                                    class MyViewModel : ViewModel() {
                                        private val viewModelScope = CoroutineScope(Dispatchers.Main)

                                        fun performBackgroundTask() {
                                            viewModelScope.launch {
                                                // Coroutine body
                                            }
                                        }

                                        override fun onCleared() {
                                            super.onCleared()
                                            viewModelScope.cancel() // Cancel all coroutines when ViewModel is cleared
                                        }
                                    }

                                    //6 Handling Cancellation Exceptions
                                    val job = CoroutineScope(Dispatchers.Default).launch {
                                        try {
                                            // Perform task
                                        } catch (e: CancellationException) {
                                            // Handle cancellation
                                        }
                                    }
                                """.trimIndent()
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "CoroutineExceptionHandlers",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Exception Handling in the case of async and await:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                     data class HomeState(
                                         val isLoading: Boolean,
                                         val posts: List<PostResponse> = emptyList(),
                                         val error: String? = null,
                                     )

                                     class HomeViewModel {

                                         private val viewModelScope = CoroutineScope(Dispatchers.IO)

                                         private val exceptionHandler = CoroutineExceptionHandler { _, throwable ->
                                             runBlocking {
                                                 _stateFlow.emit(
                                                     HomeState(
                                                         isLoading = false,
                                                         error = throwable.message.orEmpty()
                                                     )
                                                 )
                                             }
                                         }

                                         private val _stateFlow = MutableStateFlow(HomeState(isLoading = true))
                                         val stateFlow: StateFlow<HomeState> = _stateFlow.asStateFlow()

                                         fun loadPosts() = viewModelScope.launch(exceptionHandler) {
                                             val response = getPosts()
                                             _stateFlow.emit(
                                                 HomeState(
                                                     isLoading = false,
                                                     posts = response
                                                 )
                                             )
                                         }
                                     }
                                """.trimIndent()
                            )

                            Li {
                                SpanText(
                                    text = "Using Coroutinescope: Coroutinescope is used to launch multiple async and await suspended functions and the app would not crash even if its network response returns null.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Using Supervisor Scope: Supervisorscope is used in case we want to return an empty response even if a network response returns null. We can not return an empty response in case of coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "SupervisorJob",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "When using supervisor jobs, exceptions in one child coroutine won’t affect others.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "CoroutineScope’s CoroutineExceptionHandler",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "You can also specify a CoroutineExceptionHandler when creating a CoroutineScope. This handler will catch exceptions thrown by all coroutines launched within the scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Why Throw Cancellation Exceptions?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Graceful Termination: When a coroutine is canceled, it’s essential to respond appropriately. Throwing a CancellationException ensures that the coroutine terminates gracefully, allowing any necessary cleanup to occur. This avoids potential resource leaks and inconsistent application states.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Maintain Consistency: By throwing cancellation exceptions, we maintain consistency in our code. It allows us to distinguish between normal exceptions and cancellation, making our error handling logic clearer and more robust.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Lifecycle Awareness: In Android, where activity and fragment lifecycles can be unpredictable, throwing cancellation exceptions allows us to respect the lifecycle of our components. This leads to better user experiences, as we avoid running unnecessary tasks after a component has been destroyed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Debugging Ease: When cancellation exceptions are thrown, they provide valuable context for debugging. We can quickly identify where and why a coroutine was canceled, leading to faster resolutions of issues.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Improved Performance: Efficient coroutine management enhances app performance. By properly handling cancellations, we can free up resources promptly and ensure that our applications run smoothly without unnecessary processing.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                    private fun runTesting() {
                        lifecycleScope.launch {
                            val job1 = async {
                                try {
                                    delay(500)
                                } catch(e: Exception) {
                                    if(e is CancellationException) throw e
                                    e.printStackTrace()
                                }
                                println("async 1 is finished")
                            }
                            delay(300L)
                            job1.cancel()
                        }
                    }
                    """.trimIndent()
                    )
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you cancel coroutines in Kotlin? What are the best practices for coroutine cancellation in Android apps?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Cancelling coroutines in Kotlin is essential for managing resources efficiently and preventing memory leaks in long-running or background tasks.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Job’s cancel() Function",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "You can cancel a coroutine by calling the cancel() function on its corresponding Job object. This function cancels the coroutine and all its children coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Cancelling CoroutineScope",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "If you’re using a CoroutineScope to manage multiple coroutines, you can cancel all coroutines launched within the scope by cancelling the scope itself.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Cancelling Child Coroutines",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "If you’re using a supervisor job to launch child coroutines, cancelling the parent coroutine won’t cancel its children. You need to handle cancellation of child coroutines explicitly.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Handling Cancellation",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "It’s important to handle cancellation gracefully within coroutines. You can check the isActive property inside the coroutine to determine if it has been cancelled.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Structured Concurrency",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Prefer using structured concurrency, where coroutines are launched within a limited scope, such as a CoroutineScope tied to a component's lifecycle. This ensures that coroutines are cancelled automatically when the component is destroyed or no longer needed, preventing memory leaks.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "What is structured concurrency, and how do coroutines support it?",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "Structured concurrency is an approach where the lifetime of concurrent tasks is tied to a specific scope. Coroutines support structured concurrency through CoroutineScope. Coroutines launched within a scope are automatically canceled when the scope is canceled, ensuring proper cleanup and avoiding",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Handling Cancellation Exceptions",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )

                            Li {
                                SpanText(
                                    text = "If a coroutine is cancelled while performing a suspending function, a CancellationException is thrown. You can handle this exception using try/catch blocks or by invoking the CancellableContinuation's resumeWithException() function.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "A cancelled coroutine scope cannot be re-used to launch new coroutines",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The Kotlin documentation is not very explicit about this, but once cancel() is called on a coroutine scope, that scope can no longer be used to launch new coroutines and a new scope is required.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a Job in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Job represents a cancellable piece of work. It has a lifecycle and can be cancelled.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Deferred",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Deferred Job which is created by async allows you to get result of Coroutine directly in caller Coroutine. It is possible by await() methed, which internally make loop that checks state of child Coroutine, and decides whether it should suspend or return result, or throw Exception. As the result, you should handle Exception on caller Coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens when you access a Job or Deferred object after its coroutine is completed or cancelled?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If you try to access a Job or Deferred after its coroutine is completed or cancelled, the Deferred will either return a result (if it completed successfully) or throw a CancellationException (if it was cancelled). If the coroutine was completed normally, you can use await() to retrieve the result; otherwise, an exception will be thrown. Handling these cases properly requires careful exception handling to ensure your application doesn’t break unexpectedly.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is withContext? Give an example.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "WithContext is used to shift a suspend function to a particular Thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is a suspending function that is used to shift the execution of the current coroutine on a new CoroutineContext, in most cases, a different dispatcher.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It’s a suspend function whereas launch and async create a new coroutine and they are not suspend functions.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is often used to route and switch asynchronous operations.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "So its only task is to shift the suspended functions. WithContext is also suspended in nature and therefore can only be called in the coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "withContext is a suspend function through which we can do a task by providing the Dispatchers on which we want the task to be done.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                suspend fun fetchData() {
                                     withContext(Dispatchers.IO) {
                                         // fetch data
                                     }
                                }
                            """.trimIndent()
                            )
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How is delay different from Thread.sleep?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "delay is a suspending function that doesn't block the thread, whereas Thread.sleep blocks the thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is difference between an upstream and a downstream flow in kotlin coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )


                        Ul {
                            Li {
                                SpanText(
                                    text =  "𝘐𝘯 𝘱𝘢𝘳𝘵𝘪𝘤𝘶𝘭𝘢𝘳, 𝘵𝘩𝘪𝘴 𝘰𝘱𝘦𝘳𝘢𝘵𝘰𝘳 𝘦𝘯𝘴𝘶𝘳𝘦𝘴 𝘵𝘩𝘢𝘵 𝘥𝘰𝘸𝘯𝘴𝘵𝘳𝘦𝘢𝘮 𝘧𝘭𝘰𝘸 𝘥𝘰𝘦𝘴 𝘯𝘰𝘵 𝘳𝘦𝘴𝘶𝘮𝘦 𝘰𝘯 𝘤𝘢𝘯𝘤𝘦𝘭𝘭𝘢𝘵𝘪𝘰𝘯 𝘦𝘷𝘦𝘯 𝘪𝘧 𝘵𝘩𝘦 𝘦𝘭𝘦𝘮𝘦𝘯𝘵𝘸𝘢𝘴 𝘢𝘭𝘳𝘦𝘢𝘥𝘺 𝘦𝘮𝘪𝘵𝘵𝘦𝘥 𝘣𝘺 𝘵𝘩𝘦 𝘶𝘱𝘴𝘵𝘳𝘦𝘢𝘮 𝘧𝘭𝘰𝘸.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "You will see a reference to an “upstream” and a “downstream” flow everywhere in the docs.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It was challenging for me to understand what those definitions mean, so I put together an animation to help you understand as well.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Upstream flow — When you apply an intermediate operator to a flow, you are affecting the part of the flow that comes before (or “upstream of”) the operator. flowOn changes the context for all upstream operations before it in the flow chain.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Downstream flow — Side of the flow that proceeds after applying an intermediate operator. Downstream operations (e.g., collect) continue to run in the collector’s context.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What Defines a flow in Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Flow is a cold asynchronous stream of values, representing a sequence of elements emitted over time. It functions as a conduit for handling potentially infinite sequences of data in a non-blocking manner.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is flow in Kotlin?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Think of it as a river carrying data from various sources (sensors, APIs, etc) to different parts of your app.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Cold stream — it starts emitting data only when one starts to collect them. (In cold cases the producer doesn’t produce data until the consumer is not active)",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flow is a cold stream of asynchronous values. It integrates with coroutines and can produce values over time.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flow is a type that can emit multiple values sequentially, similar to how a Sequence operates, but with Flow, these values can be generated asynchronously.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Introduces a sequential stream of values that can be asynchronously computed and collected.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flow if the collector function executes on a main thread then producer function also executes on main thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Simply , we can say that, Flow assumes the running thread is the same for Collector function as well as Receiver function, if they found that the collector function runs on main and producer function runs on IO thread then it throws an Error.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It does not represent a state.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To collect from a Flow use the collect function or other coroutine-based operators.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Does not remember past values. Each time you collect from a Flow, it starts from scratch.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Examples: fetching data from the internet, reading sensor data, handling user interactions, database queries, etc.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "In terms of APIs, Flow is a fairly rich feature. It includes numerous transformation operators such as map, filter, transform, etc. that you would typically find in other stream-based libraries or languages.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain flow functions.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "onStart{}: Starting of emitting a first value from the producer.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "onCompletion{}: After Emitting all values from the producer. onCompletion operator is used to perform an action when the flow has completed, regardless of whether it completed successfully or due to an exception. This operator is similar to a finally block in a try-catch-finally statement in traditional exception handling.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                     import kotlinx.coroutines.flow.*
                                     import kotlinx.coroutines.runBlocking

                                     fun main() = runBlocking {
                                         val flow = flow {
                                             emit(1)
                                             emit(2)
                                             emit(3)
                                         }
                                         flow
                                             .onCompletion { cause ->
                                                 if (cause == null) {
                                                     println("Flow completed successfully")
                                                 } else {
                                                     println(cause)
                                                 }
                                             }
                                             .collect { value ->
                                                 println(value)
                                             }
                                     }
                                """.trimIndent()
                            )

                            Li {
                                SpanText(
                                    text = "onEach{}: Before emitting each value it executes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Collect{}: It collects all producer emitting values.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                    class MainActivity : AppCompatActivity() {
                                    override fun onCreate(savedInstanceState: Bundle?) {
                                    super. onCreate(savedInstancestate)
                                     setContentView(R.Layout.activity_main)
                                     GlobalScope.launch{
                                      producer()
                                      .onStart{
                                        Log.d( "KOTLIN_FLOW","Starting out")
                                        }
                                      .onCompletion{
                                        Log.d( "KOTLIN_FLOW","Completed")
                                        }
                                      .onEach{
                                        Log.d( "KOTLIN_FLOW","About to emit -${'$'}it")
                                        }
                                      .collect{
                                        Log.d( "KOTLIN_FLOW", it.toString())
                                        }
                                     }
                                    }
                                    fun producer()= flow<Int>{
                                     val list = listof(1,2,3,4,5,6,7,8,9,10)
                                     list.foreach{
                                      delay(1000)
                                      emit(it)
                                     }
                                    }
                                """.trimIndent()
                            )

                            KotlinCode(
                                code = """
                                     class InMemoryUserRepository @Inject constructor() : UserRepository {
                                       override fun getUsers(): Flow<List<User>> = flow {
                                         val userList = listOf(
                                           User(
                                             name = "User 1",
                                             age = 20
                                           ),
                                           User(
                                             name = "User 2",
                                             age = 30
                                           )
                                         )
                                         emit(userList.shuffled())
                                       }
                                     }

                                     interface UserRepository {
                                       fun getUsers(): Flow<List<User>>
                                     }
                                """.trimIndent()
                            )
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does a flow emit values?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Flow emits values asynchronously through a suspend function marked with the emit keyword.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "This design allows for the emission of values in a sequential manner, making it particularly suitable for handling dynamic, time-dependent data.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you observe a Flow in a composable?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "collectAsStateWithLifecycle(), collectAsState(), LaunchedEffect + collect, produceState",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "When is a flow the appropriate choice?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Flow is the preferred choice when dealing with asynchronous sequences of data, such as fetching information from a remote server or observing changes in a database.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It shines in scenarios where a continuous stream of values needs to be managed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What distinguishes a StateFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A StateFlow, introduced in the kotlinx.coroutines.flow library, is a specialized form of Flow tailored for representing and observing a singular state over time. It introduces a layer of abstraction that simplifies the management of application state.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does a StateFlow differ from a Flow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "While a Flow excels at emitting values asynchronously, a StateFlow focuses on encapsulating and broadcasting the current state to its observers. It provides a more streamlined approach to state management, especially in scenarios where a single source of truth is essential.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flows are more general-purpose and suitable for handling sequences of data, while StateFlows are specialized for managing a singular state or variable.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "When should i opt for a StateFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A StateFlow is particularly valuable when the objective is to represent and observe a singular source of truth that undergoes changes over time. Its primary strength lies in simplifying state management, making it a go-to solution for UI-related states in applications.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does StateFlow handle initialization?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Initialization in StateFlow is straightforward — it requires an initial value, which is set during the creation of the StateFlow instance. This initial value is then emitted to observers upon subscription.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can a StateFlow emit multiple values?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Yes, a StateFlow is capable of emitting multiple values over time. However, it’s essential to note that observers are notified only when there is an actual change in the state, not necessarily with every emission.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do Flows and StateFlow differ in handling collectors?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Both Flows and StateFlows are collected using the collect function. However, StateFlows offer an additional convenience through the value property, allowing direct access to the current state without the need for explicit collection.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Both Flows and StateFlows are collected using the collect function. However, StateFlows offer an additional convenience through the value property, allowing direct access to the current state without the need for explicit collection.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What are kotlin flows?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "This is a specific API introduced in Kotlin coroutines 1.3. It provides a mechanism for handling asynchronous streams of data in a structured and declarative way. Flows are like “iterators” that emit values over time as similar to RxJava Observables. They are built on top of coroutines and allowing for efficient asynchronous processing and cancellation.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain key characteristics of flows.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Asynchronous data streams: They represent a sequence of values emitted over time and allowing you to handle data updates efficiently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Built on coroutines: This enables leveraging the power of coroutines for cancellation, context switching and structured concurrency.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Cold and lazy: Flows don’t start emitting values until someone “collects” them that making them resource-efficient.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Operators: Flow provides various operators like map, filter and combine to transform and manipulate the data stream.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "State management: StateFlow and SharedFlow are special types of flows used for managing UI state and sharing data between multiple components.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Types of flows in coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Flow: Basic type for emitting a stream of data.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li {
                                    SpanText(
                                        text = "StateFlow: Holds a current state value and emits updates to subscribers.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li {
                                    SpanText(
                                        text = "SharedFlow: Similar to StateFlow but can replay previous emitted values to new subscribers.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is StateFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "StateFlow is a state-holder observable flow that emits the current and new state updates to its collectors. We can read the state by using its value property.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            SpanText(
                                text = "Here are somethings to know about StateFlows:",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                            )

                            Li {
                                SpanText(
                                    text = "Producer: The class responsible for updating the StateFlow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Consumer: The classes that are subscribed to the StateFlow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow is a hot flow: This means that regardless of whether or not you have active collectors, it will produce a value.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Always in memory: It will stay active, even if there are no collectors. If a consumer subscribes to the flow, it will receive the current state, none of the prior states.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Doesn’t trigger producer code.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain sharedFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "It’s as a river that branches out, sharing the same water (data) with multiple destinations.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Share data with multiple subscribers simultaneously. (It has multiple consumers and all consumers get the same data.)",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "A SharedFlow is a hot flow that can have multiple collectors. It can emit values independently of the collectors, and multiple collectors can collect the same values from the flow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "SharedFlow allows multiple observers (listeners) to listen to the same stream of data independently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It’s useful when you need to broadcast a value to multiple collectors or when you want to have multiple subscribers to the same stream of data.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Hot stream: like StateFlow, SharedFlow is also a hot stream.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It does not have an initial value.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "SharedFlow’s replayCache is customizable and has a default of 0. If default is used, the value will not be replayed to new subscribers as well as to existing subscribers on configuration changes (e.g. there is no reason to re-emit an error after configuration change).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To observe a SharedFlow use the collect function or other coroutine-based operators.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Can optionally have a replay cache, which means it can replay a specified number of previously emitted values to new subscribers.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Unlike StateFlow, which inherently conflates values to always represent the latest state, SharedFlow provides configurable conflation options to handle different overflow strategies.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Use emit() to emit values and suspend the caller until the value is successfully added to the sharedFlow’s buffer.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Use tryEmit() to emit values and not suspend the caller, it returns a boolean immediately if the buffer is full, enabling error handling.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Suitable for broadcasting events or updates: new messages in a chat app, theme changes, synchronize shopping cart changes, etc.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Single line answer: A hot flow that can receive elements regardless of number of consumers (there can even be no one). Has replayCache to provide recent elements (published before subscribing) for new consumers. As was mentioned earlier, this type of flow is hot. It means that you can emit without any subscriber. It’s also adapted to situations when there’s multiple possible subscribers that consumes flow with the delay by replayCache.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain StateFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "StateFlow is a hot flow so it keeps emitting values although there is no collector. It’s as a special river with a memory. It remembers the latest piece of information that flowed through it.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "A StateFlow is a hot flow that represents a state, holding a single value at a time.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is also a conflated flow, meaning that when a new value is emitted, the most recent value is retained and immediately emitted to new collectors.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is useful when you need to maintain a single source of truth for a state and automatically update all the collectors with the latest state.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It always has an initial value and only stores and exposes the latest emitted value.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow has a fixed replayCache of 1 (similar to LiveData) and replays most recent emissions to new subscribers as well as to existing subscribers on configuration changes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Hot stream: emit data regardless of whether there are subscribers.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow represents a value that can be observed over time, and whenever the value changes, you can react to it.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It has a compareAndSet function (that is actually used in the update function) to avoid inconsistency within concurrency by checking the current value of stateflow and the given one.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "update function will be called multiple times if compareAndSet returns false.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It conflates values, meaning if a new value is set before the previous one is collected, the previous value will be overwritten. It emits values only when they differ from the previous item.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To observe a StateFlow use the collect function or other coroutine-based operators.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow is initialized with a starting value. Observers can subscribe to the StateFlow to receive updates whenever the value changes. Unlike other types of Flows, StateFlow is always active once initialized, retaining the latest value and immediately emitting it to any new collectors.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "A mutable state flow is created using MutableStateFlow(value).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Its current value can be retrieved or updated via the value property.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "We usually use this type of flow in our mobile applications to observe state updates from UI-side.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "LiveData vs StateFlow",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "Livedata",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                            Li {
                                SpanText(
                                    text = "It has lifecycle awareness, which means that it will automatically stop broadcasting data when the view is no longer in the foreground.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is snap-shot based observable, which means that it only emits new values when the data changes. This can also reduce unnecessary UI updates.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is part of the Android framework, so it is tightly coupled to the Android platform.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "LiveData provides a very limited set of operators like map, switchMap, getValue, observce change in data, but it lacks many of advanced operator like in StateFlow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "LiveData does not have any built-in support for errors or exceptions handling.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "LiveData: Transformations (map, filter, combine, flatMapLatest), MediatorLiveData, switchMap",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                            SpanText(
                                text = "StateFlow",
                                modifier = Modifier.padding(topBottom = 0.2.em)
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                            Li {
                                SpanText(
                                    text = "It does not have lifecycle awareness, so we can achieve that same behavior using Lifecycle.repeatOnLifecycle.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is a hot flow, which means it will keep emitting values even there is no collector.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is not part of the Android framework, so it is decoupled further from the android platform and can be used in any Kotlin codebase.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is a part of the Kotlin Flow API library. So, it offers a rich set of operators and functionalities like map, filter, transform, zip, combine, debounce, distinctUntilChanged, scan, flatMapConcat and many more.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow has catch() operator to handle exceptions or errors.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain StateFlow update?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "value Property",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                               Li {
                                   SpanText(
                                       text = "The most straightforward way to update a StateFlow's value is by assigning a new value to its value property. This method directly modifies the StateFlow's current value and triggers an emission.",
                                       modifier = Modifier.padding(bottom = 0.2.em)
                                           .fontSize(FontSize.Medium)
                                   )
                               }

                                KotlinCode(
                                    code = """
                                         stateFlow.value = newValue
                                    """.trimIndent()
                                )

                               Li {
                                   SpanText(
                                       text = "When you assign a new value to the value property, any active collectors are notified of the change, assuming the new value is different from the old value. This distinction is necessary for collections, as merely modifying the contents of a collection without reassigning it to the value property may not trigger an update.",
                                       modifier = Modifier.padding(topBottom = 0.2.em)
                                           .fontSize(FontSize.Medium)
                                   )
                               }
                           }

                            Li {
                                SpanText(
                                    text = "update Function",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li {
                                    SpanText(
                                        text = "Kotlin provides the update function for more complex scenarios where you might want to update the current value based on its existing state. This function ensures atomic updates and is particularly useful when working with concurrent operations.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                KotlinCode(
                                    code = """
                                         stateFlow.update { currentValue ->
                                             // Return the new value based on the current value
                                         }
                                    """.trimIndent()
                                )
                            }

                            Li {
                                SpanText(
                                    text = "compareAndSet method",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li {
                                    SpanText(
                                        text = "For cases where you need to compare the current value with an expected value before updating, compareAndSet comes in handy. This method attempts to update the value only if the current value is equal to the expected value, providing a way to manage state changes safely in concurrent environments.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                KotlinCode(
                                    code = """
                                         stateFlow.compareAndSet(expect = currentValue, update = newValue)
                                    """.trimIndent()
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Flow vs. StateFlow",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Flow is a general concept representing a sequence of values over time.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow is a specific type of Flow that represents a value with a current state.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flow is typically used for asynchronous data operations.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow is often used to represent the state of an application or UI element that needs to be observed and reacted to.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Flow vs. SharedFlow",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "StateFlow is a specific type of Flow with a current state that represents the state of an application or UI element.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "SharedFlow is a more general type of Flow that allows multiple observers to access the same data stream independently.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "StateFlow is often used for representing the state of UI elements.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "SharedFlow is used when you need to share data among multiple parts of your application.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain ChannelFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "ChannelFlow The cold type of Kotlin Flows that uses Channel APIs in its builders. The peculiarity of this Flow subtype is that there is no restriction on the context of where we emit values into our Flow (we can emit them concurrently).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "ChannelFlow facilitates concurrent emission from different coroutines with structured concurrency. It’s ideal for scenarios requiring parallel processing. The first example demonstrates emission in specific coroutine contexts.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain CallbackFlow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "CallbackFlow is beneficial for integrating external updates through traditional callbacks. It seamlessly converts callback-based updates into a flow of values, bridging asynchronous APIs with Kotlin coroutines expressiveness. The awaitClose block ensures proper cleanup when the flow is no longer needed, unregistering callbacks as necessary.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you convert a callback-based API to use coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Flow emits values asynchronously through a suspend function marked with the emit keyword.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "This design allows for the emission of values in a sequential manner, making it particularly suitable for handling dynamic, time-dependent data.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you convert a callback-based API to use coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can wrap the callback using suspendCoroutine or callbackFlow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the purpose of suspendCancellableCoroutine?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "It’s a suspending function that can be cancelled. If the coroutine is cancelled, the provided block is executed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "join() vs await",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The join() and await() functions are both suspending functions that allow you to wait for the completion of a coroutine before continuing. However, there are some key differences between the two functions.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "join(): The join() function suspends the current coroutine until the coroutine associated with the Job object completes. The Job object is returned by the launch() and async() functions when you start a coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "await(): The await() function suspends the current coroutine until the coroutine associated with the Deferred object completes. The Deferred object is returned by the async() function when you start a coroutine that returns a value.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is coroutineScope vs CoroutineScope?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "coroutineScope is a suspending function that creates a new scope and doesn't complete until all launched children do. CoroutineScope is an interface that can be used to launch coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "A ‘coroutine scope’ keeps track of any coroutine it creates using ‘launch’ or ‘async’. The running coroutines can be cancelled by calling scope.cancel() at any point of time. For example, ViewModelhas a viewModelScope, and Lifecycle has lifecyclescope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a CoroutineScope, and why is it important when working with coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "CoroutineScope is an interface to create a new coroutine scope. The CoroutineScope interface provides a structured concurrency mechanism that allows developers to launch and manage coroutines within a specific scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Common scopes include GlobalScope coroutines that need to run globally and CoroutineScope coroutines tied to a specific context (like an activity or a fragment in Android development).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Alternatively, developers can use the GlobalScope object, which provides a global scope for launching coroutines that can be used throughout the entire application.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Two important elements: `launch` and `async`. These functions are used to initiate coroutines and begin their execution within the defined scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is important to note that every coroutine must be launched in a coroutine scope, as it provides a context for the coroutine to run in, and ensures that the coroutine is properly canceled when the scope is canceled or completed.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It's crucial for ensuring that launched coroutines are properly canceled when they are no longer needed, preventing resource leaks and runaway coroutines. It is often associated with a particular scope or context, like an Android ViewModel, to manage the coroutine's lifecycle.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What’s the difference between coroutineScope and supervisorScope?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The coroutineScope and supervisorScope are both Kotlin scope functions that control the lifetime of coroutines. However, they handle exceptions and child coroutine failures differently:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "coroutineScope: When a child coroutine fails (throws an exception), coroutineScope will cancel all the other child coroutines and it will also re-throw the exception. This is often used when it’s important that all child operations either complete successfully or fail altogether.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "supervisorScope: With supervisorScope, if a child coroutine fails, it does not cancel the other child coroutines. Each child is treated independently; failure of one does not imply the failure of the others. supervisorScope is useful when you have a group of largely independent tasks and want to make sure they all have the chance to complete, regardless of the success or failure of the others.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Both scopes have their use cases and their choice depends on how you want to handle failures in your coroutines. While coroutineScope promotes structured concurrency and failure propagation, supervisorScope allows for more independence and resilience among the child coroutines.",
                                        modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "CoroutineScope vs CoroutineContext",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A coroutine scope has a single property i.e. coroutine context.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Every coroutine needs to run in a specific coroutine scope and several coroutines can be started in the same scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "If a coroutine is started and some child coroutines are also started in a certain scope, then their job objects will form a parent child hierarchy.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Each of the coroutines in the hierarchy run in the same scope and by default, each coroutine inherits the context of the scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you handle error propagation in nested coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "For nested coroutines, I use supervisorScope to avoid sibling cancellation. If I launch multiple child coroutines, I wrap risky blocks with try-catch. For global error tracking, I attach a CoroutineExceptionHandler, especially for jobs not tied to UI. And I’m careful with async — always await() in try-catch to catch errors.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Job",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A Job is a handle to a coroutine. Each coroutine that we create with ‘launch’ or ‘async’ returns a Jobinstance that uniquely identifies the coroutine and manages its lifecycle. We can also pass a Job to aCoroutineScope to further manage its lifecycle.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What does runBlocking",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "runBlocking is a coroutine function.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Runs a new coroutine and blocks the current thread interruptible until its completion (It runs a new coroutine and blocks the current thread until its completion). This function should not be used inside a coroutine.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is designed to bridge non-coroutine and coroutine codes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It is designed to bridge regular blocking code to libraries that are written in suspending style, to be used in main functions and in tests.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens when runBlocking is used in a nested coroutine context?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "When runBlocking is used inside another coroutine context (which is rare but can happen), it blocks the thread of the outer coroutine until its execution completes. This defeats the purpose of non-blocking coroutines, making the parent coroutine wait unnecessarily.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Nested runBlocking calls are generally discouraged because they can lead to thread blocking and performance issues. Instead, you should rely on non-blocking coroutine builders like launch and async.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Why should runBlocking not be used in production Android code?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "It blocks the main thread, causing UI freezes and an unresponsive app.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Android development encourages non-blocking code execution to keep the UI thread responsive. Coroutines with launch and appropriate dispatchers (Dispatchers.IO for I/O operations or Dispatchers.Default for CPU-bound tasks) are preferred to achieve this.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Is runBlocking thread-safe? Can it be used in a multi-threaded environment?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Yes, runBlocking is thread-safe. However, it is generally not recommended for multi-threaded environments, especially in Android or server applications, because it blocks the current thread, which is contrary to the non-blocking philosophy of coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "In multi-threaded applications, it’s better to use non-blocking coroutine builders like launch or async in combination with appropriate dispatchers (e.g., Dispatchers.IO, Dispatchers.Default).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does runBlocking differ from runBlockingTest in Kotlin coroutines testing?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "runBlocking: It is a coroutine builder for real coroutine code, blocking the current thread while the coroutine executes. It is designed for real-time execution and should only be used in production code when necessary.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "runBlockingTest: It is specifically for testing coroutines. It does not block threads in real-time but instead advances time automatically to allow faster testing of suspending functions without actual delays. This function is part of the Kotlin coroutines testing library and should only be used in unit tests.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens if an exception is thrown inside runBlocking?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "If an exception is thrown inside runBlocking, it will propagate up to the calling thread, and the entire runBlocking scope will be cancelled. This behavior is similar to any other coroutine builder where unhandled exceptions are propagated to the parent scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "For example, in the main function, if an exception occurs in runBlocking, it will terminate the program unless the exception is caught or handled within a try-catch block.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does runBlocking handle cancellation, and what are the limitations?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "runBlocking follows the cooperative cancellation model of coroutines. If a coroutine inside runBlocking is cancelled (via job.cancel()), it will throw a CancellationException at the next suspension point (e.g., delay(), yield()). However, if the coroutine is executing code that doesn't have suspension points (like a tight loop), it won't cancel immediately.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Limitation: If a coroutine inside runBlocking doesn't check for cancellation regularly (i.e., no suspension points), the cancellation won't be immediate. You may need to manually call isActive or ensureActive() to ensure proper cancellation.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How does runBlocking manage thread blocking and coroutine execution?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "runBlocking creates a synchronous coroutine and blocks the calling thread (like the main thread) until the coroutine completes. This blocking happens by using an internal event loop that simulates blocking. It schedules coroutine tasks to be executed in the current thread and waits until they finish.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "If no dispatcher is provided, it runs on the current thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "If a dispatcher (e.g., Dispatchers.IO, Dispatchers.Default) is provided, the coroutine executes on a different thread, but the calling thread will remain blocked until the coroutine completes.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What happens when you mix runBlocking and launch in the same coroutine scope? Can this result in a deadlock or any other issues?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Mixing runBlocking and launch within the same scope can lead to deadlocks, especially if runBlocking is used on the main thread and the launched coroutine attempts to perform work on the same thread. This is because runBlocking blocks the current thread until its coroutine completes, which can prevent other launched coroutines from executing, leading to a deadlock.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "For instance, launching a coroutine inside runBlocking on the main thread can prevent the coroutine from starting if runBlocking is waiting for it to complete, causing a circular wait.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                    runBlocking {
                                        launch {
                                            // Will not run if runBlocking is blocking the main thread
                                        }
                                    }
                                """.trimIndent()
                            )

                            Li {
                                SpanText(
                                    text = "This scenario emphasizes the importance of understanding thread blocking and proper coroutine lifecycle management.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "delay() works",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "delay() is a suspending function, and when called within a coroutine, it doesn’t block the thread on which the coroutine is running.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "While the coroutine is in the suspended state during the delay, the underlying thread is free to execute other tasks or coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                Column {
                                    SpanText(
                                        text = "",
                                        modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                            .fontWeight(FontWeight.Bold)
                                    )

                                    Ul {
                                        Li {
                                            SpanText(
                                                text = "delay() takes a single argument, which is the time to pause the coroutine. The time is specified in milliseconds by default.",
                                                modifier = Modifier.padding(topBottom = 0.2.em).fontSize(FontSize.Medium)
                                            )
                                        }

                                        Li {
                                            SpanText(
                                                text = "If the coroutine is cancelled before the delay completes, the delay() function throws a CancellationException. This allows for the clean cancellation of coroutines during their execution.",
                                                modifier = Modifier.padding(topBottom = 0.2.em)
                                                    .fontSize(FontSize.Medium))
                                        }

                                        Li {
                                            SpanText(
                                                text = "The delay() function is typically used within a suspend function or a coroutine builder, such as launch or async.",
                                                modifier = Modifier.padding(topBottom = 0.2.em).fontSize(FontSize.Medium))
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can you explain the concept of coroutine context hierarchies?.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine contexts form a hierarchy, where child coroutines inherit the context of their parent coroutine. This hierarchy allows for the propagation of context elements, such as dispatchers and exception handlers, from parent to child coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the concept of coroutine context and how it affects coroutine execution.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine context is a set of elements that define the behavior and context of a coroutine, such as the dispatcher, exception handler, and other context elements.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "A coroutine context is represented by the `CoroutineContext` interface. The `CoroutineScope` interface inherits from CoroutineContext and is commonly used to create and manage coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "The context is propagated from parent coroutines to child coroutines, affecting their execution.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "It tells us that thread will execute on which threads.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is coroutine cancellation and how is it achieved? How do you ensure that coroutines are properly canceled?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine cancellation is the process of stopping the execution of a coroutine before it completes. It is achieved by calling the cancel function on a coroutine's job or by canceling a coroutine scope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To ensure proper cancellation, it's important to use structured concurrency, where all child coroutines are automatically canceled when their parent scope is canceled.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Can you explain the concept of coroutine cancellation and how it differs from thread interruption?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutine cancellation is a cooperative process where a coroutine is explicitly canceled by calling cancel() on its Job object or canceling the associated coroutine scope. Cancellation is cooperative, allowing the coroutine to clean up resources and stop its execution gracefully. Thread interruption, on the other hand, is an interrupt signal sent by one thread to another, which can lead to abrupt termination and potential resource leaks.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do different ways execute CoroutineContext?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "By default, the producer of a flow builder executes in the CoroutineContext of the coroutine that collects from it, and as previously mentioned, it cannot emit values from a different CoroutineContext.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "The repository layer shouldn’t be performing operations on Dispatchers.Main that is used by viewModelScope.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To change the CoroutineContext of a flow, use the intermediate operator flowOn. flowOn changes the CoroutineContext of the upstream flow, meaning the producer and any intermediate operators applied before (or above) flowOn. The downstream flow (the intermediate operators after flowOn along with the consumer) is not affected and executes on the CoroutineContext used to collect from the flow. If there are multiple flowOn operators, each one changes the upstream from its current location.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "flowOn(Dispatchers.IO)",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "To switch the context in which the network call is made, we use the flowOn operator and pass in the IO dispatcher, which is designed for I/O-bound operations.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "This ensures that the network call is made on a separate thread from the main thread, preventing it from blocking the UI.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the purpose of the flowOn operator in coroutine flows?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The flowOn operator is used to specify the dispatcher on which downstream operators of a flow should run. It allows you to switch the execution context of the flow, ensuring that downstream operators execute on a specific dispatcher.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "When our data in flow grows in size, the call to applySort may be slow enough to block the main thread. During such conditions Flow offers a declarative API called flowOn.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "flowOn will launch a new coroutine on the defaultDispatcher to run and collect the flow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "it will store the results in the buffer then emit the results from the buffer",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "use flowOn with large objects such as Room results.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "while sending the data to UI, we have to pass the most recent results only so we use the conflate operator",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "mapLatest",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "mapLatest() transformation function which is equivalent to LiveData’s switchMap() for a single return value (for multiple return values, flatMapLatest() should be used).",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "mapLatest() works like map() but instead of fully executing the transformation on all input values in sequence, the input values are consumed immediately and the transformation is executed asynchronously in a separate coroutine. When a new value is emitted in the upstream flow, the transformation coroutine for the previous value will be canceled immediately if it was still running and a new one will be launched to replace it.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "collect vs collectLatest",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Kotlin Flow provides many operators for processing asynchronous data flows, the most basic of which is collect. The collect operator should be used when you need to get all emitted values from the stream.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "when you only need the latest value in the stream, you can use collectLatest. collectLatest immediately cancels or ignores the previous collection and starts a new collection when it receives the latest emission value.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the types of job state.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "In addition to cancelling jobs, while jobs are being executed, you can call any of its boolean properties to check its status:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "isActive — True when the job has started but is not yet complete or cancelled",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "isComplete — True when a job has either been cancelled or completed with success or failure",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "isCancelled — True when a job is.. well… cancelled",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Jobs can also perform attachChild(), join(), and start() methods, although more on them another day.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What can do in Kotlin Coroutines.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A SupervisorJob is a type of Job that is used to create a supervisory context for coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "When you create a SupervisorJob and use it as the parent for coroutines, it changes the behavior of coroutine cancellation. If a child coroutine of a SupervisorJob is cancelled, it does not automatically cancel its siblings.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "This means that a failure or cancellation in one child coroutine does not affect the other child coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the main difference between Job and SupervisorJob in Kotlin coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = " In a Job hierarchy, the failure of any child coroutine cancels all children and the parent. In contrast, a SupervisorJob ensures that the failure of a child coroutine does not affect other children or the parent, allowing them to continue their execution.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you specify a timeout for a coroutine to prevent it from running indefinitely?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can use the withTimeout or withTimeoutOrNull functions to specify a timeout for a coroutine. withTimeout throws a TimeoutCancellationException if the specified timeout is exceeded, while withTimeoutOrNull returns null instead of throwing an exception.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text =  "Sometimes we need to cancel the coroutine after some time, it can be achieved easily with 𝐰𝐢𝐭𝐡𝐓𝐢𝐦𝐞𝐨𝐮𝐭𝐎𝐫𝐍𝐮𝐥𝐥 function.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = """
                                     suspend fun performTask(): String {
                                         delay(2000) // Simulate a long-running task
                                         return "Task completed successfully!"
                                     }

                                     fun withTimeoutDemo(): String = runBlocking {
                                         val result = withTimeout(1000) {
                                             performTask()
                                         }
                                         result
                                     }
                                """.trimIndent()
                            )

                            KotlinCode(
                                code = $$"""
                                     import kotlinx.coroutines.*

                                     fun main() = runBlocking {
                                         val result = withTimeoutOrNull(1300L) {
                                             repeat(1000) { i ->
                                                 println("job: I'm working step $i...")
                                                 delay(500L)
                                             }
                                             "Done"
                                         }
                                         println("Result is $result")
                                     }
                                """.trimIndent()
                            )
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you handle backpressure in coroutine flows?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Backpressure in coroutine flows can be handled using flow operators like buffer, conflate, or collectLatest. These operators allow you to control the rate of emission and consumption of values, preventing overflow or slowdowns due to backpressure.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the role of Coroutines and Flow in Kotlin for Android development.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Coroutines: They simplify asynchronous programming by making code more readable and easier to manage. Coroutines allow you to write sequential-looking code while performing tasks in the background, avoiding callback hell.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Flow: It’s a reactive stream API that works with coroutines to handle asynchronous data streams, emitting multiple values over time.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How can you combine multiple coroutine flows into a single flow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "You can combine multiple coroutine flows using operators like zip, combine, flattenConcat, or flatMapConcat. These operators allow you to merge values emitted by multiple flows into a single flow, enabling complex data processing scenarios.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Difference between flatMapConcat and FlatMapMerge in Kotlin flow.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "FlatMapConcat : Flattening Nested Flows Sequentially. The flatMapConcat operator allows you to merge multiple Flows into a single Flow, ensuring that emissions occur sequentially. Each new Flow will complete before the next begins.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "FlatMapMerge : Parallel Flow Processing. The flatMapMerge operator also merges multiple Flows, but it does so concurrently rather than sequentially. This allows emitted items to interleave if one Flow takes longer than another.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the difference between live data and state flow?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "In the case of live data, all the transformations happened on the main thread means all the operators like map, filter, and Switch map execute on the main thread. If some heavy operation happens in the operator then it will freeze the main thread. since state flow is a flow and it has a property of flowOn.So, we can execute it on any thread.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Live data has a limited number of operators since state flow is also a flow so it has more number of operators as compared to live data.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Live data is lifecycle-aware so, it needs a lifecycle to work either activity lifecycle or fragment lifecycle, etc. We can’t use it without a cycle for example in the case of a repository we don’t have a lifecycle it is a simple class. in that scenario, we should use flow.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "So, In the case of live data, we need lifecycle but in the case of flow, we just need coroutine scope. and coroutine scope is easily manageable and efficient too.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is the coroutineName?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The CoroutineContext can hold other elements like CoroutineName, which is used for debugging purposes, or custom elements for handling specific needs. For example, CoroutineName(\"MyCoroutine\") allows you to assign a name to the coroutine, making it easier to track in logs.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you handle resource cleanup in Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Resource cleanup in coroutines can be handled using the `finally` block or the `use` extension function for resources implementing `Closeable` or `AutoCloseable`. This ensures that resources are released even if an exception occurs.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "How do you test code that involves Kotlin Coroutines?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Testing coroutine code can be done using libraries like `kotlinx-coroutines-test`, which provides utilities for testing suspending functions and coroutines in a controlled environment. You can use `TestCoroutineDispatcher` to control the execution of coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain how Kotlin coroutines interact with the Java ExecutorService. Can a coroutine run on an ExecutorService thread?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "Testing coroutine code can be done using libraries like `kotlinx-coroutines-test`, which provides utilities for testing suspending functions and coroutines in a controlled environment. You can use `TestCoroutineDispatcher` to control the execution of coroutines.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "Yes, coroutines can run on an ExecutorService thread.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = " While coroutines are typically scheduled via dispatchers, Kotlin provides a way to integrate coroutines with Java’s ExecutorService by converting the executor into a coroutine dispatcher. This can be done using the asCoroutineDispatcher() extension function.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "By doing so, coroutines can be dispatched on threads managed by the ExecutorService.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            KotlinCode(
                                code = $$"""
                                     val executor = Executors.newFixedThreadPool(2)
                                     val dispatcher = executor.asCoroutineDispatcher()

                                     GlobalScope.launch(dispatcher) {
                                         println("Running on Executor thread: ${Thread.currentThread().name}")
                                     }
                                """.trimIndent()
                            )

                            Li {
                                SpanText(
                                    text = "However, caution is needed when managing coroutines and thread-pooling interactions, as incorrect usage can lead to resource leaks or inefficient task scheduling.",
                                    modifier = Modifier.padding(bottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "What is a “coroutine leak” and how do you prevent it in Android or JVM backend applications?",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "A coroutine leak happens when a coroutine continues to run after it should be cancelled, often because the reference to the coroutine is retained beyond its useful lifetime. This is particularly problematic in UI-based applications where coroutines continue executing even after the user navigates away from the current screen.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li {
                                SpanText(
                                    text = "To prevent coroutine leaks:",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ol {
                                Li {
                                    SpanText(
                                        text = "Use scoped coroutines such as lifecycleScope or viewModelScope in Android.",
                                        modifier = Modifier.padding(bottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li {
                                    SpanText(
                                        text = "Properly handle coroutine cancellation by ensuring all coroutines are canceled when the lifecycle or scope ends.",
                                        modifier = Modifier.padding(bottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li {
                                    SpanText(
                                        text = "Avoid launching coroutines in the global scope where they may outlive the parent component.",
                                        modifier = Modifier.padding(bottom = 0.2.em)
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li {
                    Column {
                        SpanText(
                            text = "Explain the purpose of the actor coroutine builder in Kotlin?.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li {
                                SpanText(
                                    text = "The actor coroutine builder is used to create a coroutine that receives and processes a stream of messages. It provides a convenient way to implement actors, which are entities that encapsulate state and process messages sequentially, ensuring that only one message is processed at a time.",
                                    modifier = Modifier.padding(topBottom = 0.2.em)
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }
            }

            //Mind Test
            KotlinCode(
                code = """
                    // In Activity
                    override fun onCreate(savedInstanceState: Bundle?) {
                        super.onCreate(savedInstanceState)
                           
                        lifecycleScope.launch {
                            println("a")
                        }
                        
                        GlobalScope.launch {
                            println("b")
                        }

                        println("c")
                    }
                    
                    "a" runs first — executed immediately on the main thread.
                    "c" runs next — it’s just a normal synchronous call.
                    "b" runs last — scheduled on a background thread from the global pool.
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        fun OutputForA() {
                            println("Start")

                            runBlocking {
                                launch {
                                    delay(1000)
                                    println("Hello")
                                }

                                println("World")
                                delay(2000)
                            }
                        }

                        //Start - World - Hello

                        fun OutputForA() {
                            GlobalScope.launch {
                                delay(1000)
                                println("Hello")
                            }
                            println("World")
                            Thread.sleep(2000)
                        }

                        //World - Hello
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    // retry with exponential backoff
                    // inspired by https://stackoverflow.com/questions/46872242/how-to-exponential-backoff-retry-on-kotlin-coroutines
                    private suspend fun <T> retry(
                        times: Int,
                        initialDelayMillis: Long = 100,
                        maxDelayMillis: Long = 1000,
                        factor: Double = 2.0,
                        block: suspend () -> T
                    ): T {
                        var currentDelay = initialDelayMillis
                        repeat(times) {
                            try {
                                return block()
                            } catch (exception: Exception) {
                                Timber.e(exception)
                            }
                            delay(currentDelay)
                            currentDelay = (currentDelay * factor).toLong().coerceAtMost(maxDelayMillis)
                        }
                        return block() // last attempt
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Avoiding Duplicate Calls

                    class MakeTransferViewModel(
                        private val transfersRepository: TransfersRepository
                    ) : ViewModel() {

                        private val _uiState = MutableStateFlow<MakeTransferUiState>(...)
                        val uiState: StateFlow<MakeTransferUiState> = _uiState.asStateFlow()

                        private var makeTransferJob: Job? = null

                        fun tryTransfer() {
                            if (makeTransferJob != null) return

                            makeTransferJob = viewModelScope.launch {
                                try {
                                    _uiState.update { it.copy(isLoading = true) }
                                    val isTransferSuccessful = transfersRepository.makeTransfer(...)

                                    _uiState.update {
                                        it.copy(
                                            isLoading = false,
                                            transferResult = TransferResult(it.transferInfo, isTransferSuccessful)
                                        )
                                    }
                                } catch (ioe: IOException) {
                                    _uiState.update {
                                        it.copy(isLoading = false, error = ioe.message ?: "Error doing transfer")
                                    }
                                } finally {
                                    makeTransferJob = null
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

//https://medium.com/@myselfdew01/coroutine-kotlin-android-interview-questions-ae7c667f7695
//https://medium.com/@ersumansaurav1991/kotlin-coroutines-uestions-ea406919a7b0
//https://medium.com/@sharmapraveen91/10-advanced-kotlin-coroutines-interview-questions-with-performance-issues-a018ec389db9
//https://medium.com/lets-build-app-with-aayush/interview-questions-for-kotlin-coroutines-c83728dff7a3